// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__laGEn","heading-1":"Heading_heading-1__Dx2F4","heading-2":"Heading_heading-2__ymTe5","heading-3":"Heading_heading-3__UXeKr"};